import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Card, Stack } from '@servicetitan/design-system';
import { SidebarButtonComponentProps } from '../visit-assistant-sidebar/visit-assistant-sidebar';
import styles from './visit-assistant-sidebar-button-desktop.less';

export const VisitAssistantSidebarButtonDesktop: React.FC<SidebarButtonComponentProps> = (
    props
) => {
    const { backgroundImageClassName, title, link } = props;

    return (
        <NavLink to={link} className="m-b-2">
            <Card raised thin className={styles.buttonContainer}>
                <Stack alignItems="center">
                    <div
                        className={classnames(
                            styles.buttonBackgroundImage,
                            backgroundImageClassName
                        )}
                    />
                    <div className={styles.buttonTitle}>{title}</div>
                </Stack>
            </Card>
        </NavLink>
    );
};
